import { render } from "./CardFunctionality.vue?vue&type=template&id=6c2c7a2c"
const script = {}

import exportComponent from "/builds/aquaverse/thales/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__